import { render } from "./BaseContainer.vue?vue&type=template&id=3705b8d2&scoped=true"
const script = {}

import "./BaseContainer.vue?vue&type=style&index=0&id=3705b8d2&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3705b8d2"]])

export default __exports__